import React, { useState } from "react";
import styles from "./heroSection.module.scss";
import Image from "next/image";
import PlayIcon from "../../../assets/svg/PlayIcon";
import videoPosterWeb from "@assets/images/homepage/hero-demo-video-bg.webp";

import VideoModal from "../VideoModal";

export default function VideoTile({ data, setIsAnyModalOpen }) {
  const [modal, setModal] = useState(false);

  const openModal = () => {
    setModal(!modal);
    if(!modal){
      setIsAnyModalOpen(true);
    }
    else{
      setIsAnyModalOpen(false);
    }
  };

  return (
    <div
      className={`${styles.videoTileContainer} cursor-pointer rounded-[8px] lg:rounded-[14px] w-full max-w-fit lg:right-16 flex items-center md:flex-col lg:left-auto mt-8 md:mt-0 mr-auto hover:scale-105 transition-transform duration-200 ease-in-out border border-primary border-neutral-200`}
      onClick={openModal}
    >
      <div className="relative w-[86px] h-[48px] md:w-[216px] md:h-[120px]">
        <Image
          priority
          src={videoPosterWeb}
          alt="Video Tile Poster"
          className="rounded-[8px] lg:rounded-[16px]"
          sizes="(max-width: 768px) 86px, 216px"
        />
        <PlayIcon />
      </div>
      <VideoModal isOpen={modal} openModal={openModal} data={data} videoTrackingName="Matic vs NYC" />
    </div>
  );
}
